import { render, staticRenderFns } from "./highlights.view.vue?vue&type=template&id=c6d76780&scoped=true"
import script from "./highlights.view.vue?vue&type=script&lang=ts"
export * from "./highlights.view.vue?vue&type=script&lang=ts"
import style0 from "./highlights.view.vue?vue&type=style&index=0&id=c6d76780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d76780",
  null
  
)

export default component.exports